import styled from "styled-components"

export const Popup = styled.div`.slogan {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: black;
    margin-bottom: 15px;
    margin-left: 15px;
}

.info {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* .class500 {
    font-size: 150px;
    font-weight: bold;
    margin-bottom: -50px;
} */

.input {
    width: 100%;
    font-size: 20px;
    font-weight: 500;
    position: relative;
    background-color: #fff;
    color: rgb(0, 0, 0);
    padding: 10px 10px 10px 55px;
    outline: none;
    border-radius: 4px;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
    border-image: initial;
    margin-bottom: 0 !important;
}
.inputDiv {
	margin-bottom: 20px !important;
}
.input::placeholder {
	color: black;
	font-size: 0.8 em;
}
/* The Modal (background) */
.modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    /*z-index: 1;*/ /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */

}

#divContainer {
		padding:0;
        margin: 0;
		width: 100%;
        height: 100%;
}


.sendMail {
    width: 100%;
    height: 48px;
    background-color: #9ecd49;
    color: white;
    border: 0;
    font-weight: bold;
    border-radius: 3px;
}

/* Modal Content */
.modal-content {
    margin: auto;
    background: #f8f8f8;
    border: 0;
    padding: 50px 30px 50px 30px;
   
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top: 45px;
    
    position: relative;
}

.close_x {
	background-color: #9ecd49;
    width: 35px;
    position: absolute;
    top: -138px;
    left: 784px;
    cursor: pointer;
    
}

.modalheader {
    position: absolute;
    top: 125px;
    right: 800px;
    z-index: 100;
}

.rodo_consent {
    width: 100%;
    font-size: 11px;
    text-align: left;
    color: #495057;
    margin-bottom: 5px;
}

/* The Close Button */
.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}
 
 .textarea {
	 resize: none;
	 margin-bottom: 3px !important;
	 height: 80px ;
	 width: 100%;
	 font-size: 20px;
	 font-weight: 500;
	 position: relative;
	 background-color: #fff;
	 color: rgb(0, 0, 0);
	 padding: 10px 10px 10px 55px;
	 outline: none;
	 border-radius: 4px;
	 border-width: 2px;
	 border-style: solid;
	 border-color: transparent;
	 border-image: initial;
	 padding: 10px 10px 10px 25px;
	 height: 120px ;
 }
 div.textarea {
 	height: 80px;
 }
 .textarea p {
	 padding: 0px;
	 margin-left: 25px;
	 margin-top: -5px;
	 height: auto;
	 width: auto;
 }
 textarea::placeholder {
	 color: grey;
	 font-size: 95%;
 }
 p.code {
	 color: grey;
	 font-size: 90%;
	 padding: 0px;
 }
 
 .btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}
.contactform{
	width: 100%;
}
@media (max-width : 430px) {
    .container {
        padding:0;
        margin: 0;
    }
    
    .close_x {
    top: -121px;
    left: 767px;
	}
}`
/*.popup-content {*/
/*    background: #fac20e;*/
/*    border: 0px;*/
/*    padding: 50px;*/
/*    display: flex;*/
/*    flex-wrap: wrap;*/
/*    width: 815px;*/
/*}*/

/* .get500 {
    font-size: 50px;
    font-weight: bold;
    margin-bottom: -60px;
}
 */
